module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title29"
    }
  }), _c('div', {
    staticClass: "title-toc"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781466822047_tp01",
      "id": "toctitle26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Title Page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781466822047_fm02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Tor Copyright Notice")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466822047_c01",
      "id": "toctitle1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter One")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("EVE OF THE WAR")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466822047_c02",
      "id": "toctitle2"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("Chapter Two")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("IN ALPINDRAK PALACE")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466822047_c03",
      "id": "toctitle3"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("Chapter Three")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE FALLING STAR")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466822047_c04",
      "id": "toctitle4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("Chapter Four")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("ON WHARFWAY PLAZA")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466822047_c05",
      "id": "toctitle5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Five")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE CYLINDER OPENS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466822047_c06",
      "id": "toctitle6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Six")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("HOW I REACHED MY ROOM")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466822047_c07",
      "id": "toctitle7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Seven")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE SORCERESS AND THE HEAT BEAM")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466822047_c08",
      "id": "toctitle8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Eight")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE FIGHTING BEGINS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466822047_c09",
      "id": "toctitle9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Nine")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("IN THE STORM")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466822047_c10",
      "id": "toctitle10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Ten")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("WHAT I SAW OF THE DESTRUCTION OF GATROV")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466822047_c11",
      "id": "toctitle11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Eleven")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("DEAD GATROV")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466822047_c12",
      "id": "toctitle12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Twelve")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("WHAT WE SAW FROM THE RUINED TAVERN")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466822047_c13",
      "id": "toctitle13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Thirteen")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("HOW WE SPOKE WITH THE LUPANIAN")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466822047_c14",
      "id": "toctitle14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Fourteen")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE DEATHS OF THE SORCERERS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466822047_c15",
      "id": "toctitle15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Fifteen")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("“THE BANKS OF THE ALBER”")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466822047_c16",
      "id": "toctitle16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Sixteen")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("DEATH OF A GLASS DRAGON")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466822047_c17",
      "id": "toctitle17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Seventeen")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("DINNER WITH MOTHER")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466822047_c18",
      "id": "toctitle18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Eighteen")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("EXODUS FROM ALBERIN")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466822047_c19",
      "id": "toctitle19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Nineteen")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("ALBERIN AGAINST THE LUPANIANS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466822047_c20",
      "id": "toctitle20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Twenty")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("MEGAZOID")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466822047_c21",
      "id": "toctitle21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Twenty-One")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("TEMPORIANS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466822047_c22",
      "id": "toctitle22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Twenty-Two")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("“EVENING’S ALL FOR COURTING”")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466822047_c23",
      "id": "toctitle23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Twenty-Three")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("ALBERIN ALONE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466822047_c24",
      "id": "toctitle24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter Twenty-Four")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("WRECKAGE")])])]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_acknowPage",
    attrs: {
      "href": "#/e9781466822047_ack01",
      "id": "toctitle25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_alsoby",
    attrs: {
      "href": "#/e9781466822047_als01",
      "id": "toctitle30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Also by")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_praisePage",
    attrs: {
      "href": "#/e9781466822047_pra01",
      "id": "toctitle31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Praise")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781466822047_cop01",
      "id": "toctitle27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Page")])]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59d6ecda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781466822047_toc01.vue
// module id = 69
// module chunks = 0